import React from "react";
import { Footprints, Bike } from "lucide-react";
import { useLang } from "@/context/LangContext";

const ModeToggle = ({ mode, setMode }) => {
  const { t } = useLang();
  return (
    <div
      data-testid="mode-toggle"
      role="tablist"
      aria-label="Walk or bike mode"
      className="inline-flex items-center bg-pietra-light/95 border border-carrubo/20 rounded-full p-1"
    >
      <button
        role="tab"
        aria-selected={mode === "walk"}
        data-testid="mode-walk"
        onClick={() => setMode("walk")}
        className={`inline-flex items-center gap-2 px-5 py-2 text-sm font-semibold tracking-wide rounded-full transition-all ${
          mode === "walk" ? "bg-carrubo text-pietra-light shadow-sm" : "text-grafite hover:text-carrubo"
        }`}
      >
        <Footprints size={16} />
        {t("hero_cta_walk")}
      </button>
      <button
        role="tab"
        aria-selected={mode === "bike"}
        data-testid="mode-bike"
        onClick={() => setMode("bike")}
        className={`inline-flex items-center gap-2 px-5 py-2 text-sm font-semibold tracking-wide rounded-full transition-all ${
          mode === "bike" ? "bg-carrubo text-pietra-light shadow-sm" : "text-grafite hover:text-carrubo"
        }`}
      >
        <Bike size={16} />
        {t("hero_cta_bike")}
      </button>
    </div>
  );
};

export default ModeToggle;
